import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { replace } from "connected-react-router";

import { func, shape } from "prop-types";
import { bool, string } from "yup";

import { actions as accountsActions, selectors as accountsSelectors } from "reducers/accounts";

import Notification from "pages/_components/Notification";
import PageLoading from "pages/_components/PageLoading";
import I18n from "pages/_components/I18n";
import CustomProductHead from "pages/_components/CustomProductHead";
import ViewTitle from "pages/_components/header/components/ViewTitle";

import Options from "pages/accounts/_components/Options";
import AccountAction from "pages/accounts/_components/AccountAction";

import MainContainer from "pages/_components/MainContainer";

import gaEventTracker, { events } from "util/gaEventTracker";
import { isIOS, isMobile } from "react-device-detect";
import CustomText from "pages/_components/CustomText/CustomText";
import HistoricalBalancesList from "./_components/HistoricalBalancesList";

class HistoricalBalances extends Component {
    static propTypes = {
        account: shape({
            idProduct: string,
            productType: string.isRequired,
            extraInfoMarked: string,
        }).isRequired,
        historicalBalances: shape({}).isRequired,
        dispatch: func.isRequired,
        fetching: bool.isRequired,
        idAccount: string.isRequired,
        isDesktop: bool.isRequired,
        fetchingHistoricalBalance: bool.isRequired,
    };

    componentDidMount() {
        const { dispatch, ...rest } = this.props;
        dispatch(accountsActions.readAccount(rest.match.params.id));
        dispatch(accountsActions.setAccountDate());

        this.setState({});
        gaEventTracker.triggerEvent(events.cuentas_saldos_historicos());
    }

    handleBack = () => {
        const { dispatch, ...rest } = this.props;

        dispatch(replace(`/accounts/${rest.match.params.id}`));
    };

    render() {
        const { account, fetching, isDesktop, fetchingHistoricalBalance } = this.props;
        const ProductInfo = () => {
            const { accountNumber } = account;
            const numMasked = `····${accountNumber?.slice(-4)}`;
            const types = { CA: "savings", CC: "checking", CE: "specialChecking", CBB: "CBB" };
            return (
                <>
                    <div
                        className={
                            isIOS || isMobile
                                ? "mb-5 py-5 acct-number d-flex justify-between box box-primary box-text-primary"
                                : "account-type"
                        }>
                        <CustomText text={`accounts.productType.${types[account.productType]}`} textType="I18N" />
                        <CustomText className="content-data-strong" text={` Nº ${numMasked}`} />
                    </div>
                </>
            );
        };

        return (
            <PageLoading loading={fetching || fetchingHistoricalBalance}>
                {!fetching && account && (
                    <Fragment>
                        <Notification scopeToShow="account/historicalBalances" />
                        <CustomProductHead
                            titleId="accounts.historicalBalances.title"
                            className="movement-details"
                            onBack={this.handleBack}>
                            <div className="toolbar-item view-title">
                                <ViewTitle id="accounts.historicalBalances.title" />
                            </div>
                        </CustomProductHead>
                        <MainContainer>
                            <div className="container">
                                <ProductInfo account={account} />
                                <HistoricalBalancesList {...this.props} />
                            </div>
                        </MainContainer>
                        {!isDesktop && (
                            <Options>
                                <AccountAction labelKey="global.download.pdf" />
                                <AccountAction labelKey="global.download.xls" />
                            </Options>
                        )}
                    </Fragment>
                )}
            </PageLoading>
        );
    }
}

const mapStateToProps = (state) => ({
    account: accountsSelectors.getSelectedAccount(state),
    fetching: accountsSelectors.getFetching(state),
    fetchingHistoricalBalance: accountsSelectors.getFetchingAgreements(state),
    historicalBalances: accountsSelectors.getHistoricalBalances(state),
});

export default connect(mapStateToProps)(HistoricalBalances);
